import React from "react";
import {Box, Column, Columns, Control, Input, TextArea, Title} from "@allxsmith/bestax-bulma";


export default function PartEnquiryJobSection({job, disabled, onChange}){


    return (
        <div>
            <Box>
                <details>
                    <summary><Title>Part Enquiry Information</Title></summary>
                    <Columns isMultiline>
                        <Column>
                            <label className="label">Registration</label>
                            <Control>
                                <Input
                                    type={"text"}
                                    name={"enquiry_registration"}
                                    value={job ? job.enquiry_registration : ""}
                                    disabled={disabled}
                                    onInput={onChange}
                                />
                            </Control>
                        </Column>
                        <Column>
                            <label className="label">Make</label>
                            <Control>
                                <Input
                                    type={"text"}
                                    name={"enquiry_make"}
                                    value={job ? job.enquiry_make : ""}
                                    disabled={disabled}
                                    onInput={onChange}
                                />
                            </Control>
                        </Column>
                        <Column>
                            <label className="label">Model</label>
                            <Control>
                                <Input
                                    type={"text"}
                                    name={"enquiry_model"}
                                    value={job ? job.enquiry_model : ""}
                                    disabled={disabled}
                                    onInput={onChange}
                                />
                            </Control>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <label className="label">Description</label>
                            <Control>
                                <TextArea
                                    name={"enquiry_description"}
                                    value={job? job.enquiry_description : ""}
                                    disabled={disabled}
                                    onInput={onChange}
                                />
                            </Control>
                        </Column>
                    </Columns>
                </details>
            </Box>
        </div>
    );

}